import { render, staticRenderFns } from "./FormContainerBlock.vue?vue&type=template&id=643d090c&"
import script from "./FormContainerBlock.vue?vue&type=script&lang=js&"
export * from "./FormContainerBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('643d090c')) {
      api.createRecord('643d090c', component.options)
    } else {
      api.reload('643d090c', component.options)
    }
    module.hot.accept("./FormContainerBlock.vue?vue&type=template&id=643d090c&", function () {
      api.rerender('643d090c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/blocks/FormContainerBlock/FormContainerBlock.vue"
export default component.exports